export const UPLOAD_DOCUMENT_SUCCESS = 'UPLOAD_DOCUMENT_SUCCESS';

export const uploadDocumentSuccess = document => ({
    type: UPLOAD_DOCUMENT_SUCCESS,
    payload: { document },
});
